// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__21My4","detailsBorder":"styles_detailsBorder__ermcC"};